import { render } from "./agent-headshot.vue?vue&type=template&id=b61b4346"
import script from "./agent-headshot.vue?vue&type=script&lang=js"
export * from "./agent-headshot.vue?vue&type=script&lang=js"

import "./agent-headshot.vue?vue&type=style&index=0&id=b61b4346&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/agent-headshot.vue'],['render',render],['__file',"agent-headshot.vue"]])

export default __exports__